import { AlertCircleIcon } from "lucide-react-native";
import React from "react";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
} from "../ui/form-control";

type FormErrorProps = {
  message: string;
} & React.ComponentProps<typeof FormControl>;

const FormError = React.memo((props: FormErrorProps) => {
  const { message, ...restProps } = props;
  return (
    <FormControl {...restProps}>
      <FormControlError>
        <FormControlErrorIcon as={AlertCircleIcon} className="mr-1" />
        <FormControlErrorText>{message}</FormControlErrorText>
      </FormControlError>
    </FormControl>
  );
});

FormError.displayName = "FormError";

export default FormError;
